
import {parse as libYAMLParse} from 'yaml';

export const yamlParse = (yamlSource) => {
  return libYAMLParse(yamlSource);
};
